import { ContentLocalizationStatus } from '@today/types'
import { Badge } from '@today/ui-primitives'
import type { ReactElement } from 'react'
import type { ContentChipLabel, Translate } from './content-types'

type Variant = 'primary' | 'secondary' | 'danger' | 'success' | 'muted'

const VARIANT: Record<ContentChipLabel, Variant> = {
	[ContentLocalizationStatus.DRAFT]: 'muted',
	[ContentLocalizationStatus.IN_REVIEW]: 'primary',
	[ContentLocalizationStatus.APPROVED]: 'secondary',
	[ContentLocalizationStatus.PUBLISHED]: 'success',
	scheduled: 'secondary',
	[ContentLocalizationStatus.RETIRED]: 'muted',
	missing: 'danger',
}

/**
 * Props for {@link StatusChipView}.
 *
 * @property locale - Prefixes the label (`es-ES · published`) when given.
 * @property label - The status label; its catalog key is `status.<label>`.
 */
export interface StatusChipViewProps {
	t: Translate
	label: ContentChipLabel
	locale?: string
}

/**
 * A language status chip (organism of the content screens). The status is
 * always spelled out as text; colour only reinforces it.
 */
export function StatusChipView({ t, label, locale }: StatusChipViewProps): ReactElement {
	const text = t(`status.${label}`)
	return (
		<Badge variant={VARIANT[label]} size="sm">
			{locale ? `${locale} · ${text}` : text}
		</Badge>
	)
}
